import React from "react";
import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface CommentModeIndicatorProps {
  onDisable: () => void;
}

export const CommentModeIndicator: React.FC<CommentModeIndicatorProps> = ({
  onDisable,
}) => {
  return (
    <div
      className="feedbackflow-mode-indicator-wrapper"
      style={{
        position: "fixed",
        insetLeft: 0,
        insetRight: 0,
        top: "1rem",
        display: "flex",
        justifyContent: "center",
        zIndex: 2147483647,
        colorScheme: "light",
        color: "#1f2937",
        fontSize: "14px",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <div
        className="feedbackflow-mode-indicator fixed inset-x-0 top-4 flex justify-center"
        style={{ zIndex: 2147483647 }}
      >
        <div
          className="bg-white shadow-lg rounded-full px-4 py-2 flex items-center space-x-3 border border-gray-200 ring-2 ring-[#9747FF]/30 shadow-[0_0_15px_rgba(151,71,255,0.4)]"
          style={{
            backgroundColor: "#ffffff !important" as any,
            color: "#1f2937 !important" as any,
            border: "1px solid #e5e7eb !important" as any,
            background: "#ffffff",
          }}
        >
          <PencilIcon
            className="w-4 h-4 text-indigo-600"
            style={{
              color: "#4f46e5 !important" as any,
              width: "16px !important" as any,
              height: "16px !important" as any,
            }}
          />
          <span
            className="text-sm font-medium"
            style={{
              color: "#1f2937 !important" as any,
              fontSize: "14px !important" as any,
              fontWeight: "500 !important" as any,
            }}
          >
            Comment mode is enabled | ESC
          </span>
          <button
            onClick={onDisable}
            className="text-gray-400 hover:text-gray-600"
            style={{
              color: "#9ca3af !important" as any,
              background: "none !important" as any,
              border: "none !important" as any,
            }}
          >
            <XMarkIcon
              className="w-4 h-4"
              style={{
                color: "#9ca3af !important" as any,
                width: "16px !important" as any,
                height: "16px !important" as any,
              }}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
